import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const getBrowserFingerprint = async () => {
  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
  } catch (error) {
    console.error("Fingerprint generation failed:", error);
    return null;
  }
};